import React, { useCallback, useEffect, useState } from 'react';
import { isMobileOnly } from 'react-device-detect';
import { FaCheck, FaTimes } from 'react-icons/fa';
import { useAuth } from '../../contexts/authContext';
import { useSteps } from '../../contexts/stepContext';
import { useAppTranslation } from '../../hooks/useAppTranslation';
import { getParamQuery } from '../../services/optIn';
import { Title } from '../../styles/global';
import { AlertBox } from '../AlertBox';
import { Content } from '../BodyStep/styles';
import Button from '../Button';
import {
  BadgeResult,
  MessageError,
  ProfileContent,
  ProfileData,
  ResultContent,
} from './styels';

const Result: React.FC = () => {
  const [optinText, setOptinText] = useState<string>('');

  const {
    selfie,
    name,
    documentNum,
    clearData,
    result,
    messageError,
    setMessageError,
    handleReturnCurrentStep,
    serviceError,
  } = useSteps();
  const { accessDash, signOut } = useAuth();
  const { translationPage } = useAppTranslation();
  const { tp } = translationPage(tr => tr.components.result);

  const handleTryAgain = () => {
    handleReturnCurrentStep();
    setMessageError('');
  };
  const returnToPlatform = useCallback(() => {
    signOut();
  }, [signOut]);

  useEffect(() => {
    getParamQuery().then(response => setOptinText(response.param.par_valor));
  }, []);
  return (
    <Content>
      {serviceError && <BadgeResult>{serviceError}</BadgeResult>}

      <Title>{tp('title')}</Title>
      <ProfileContent>
        {!isMobileOnly && <img src={selfie} alt="" />}
        <ProfileData>
          {name && (
            <>
              <p>{tp('fullName')}</p>
              <span>{name}</span>{' '}
            </>
          )}
          <p>{tp('document')}</p>
          <span>{documentNum}</span>
          <ResultContent mode={result}>
            {result === 'success' && (
              <p>
                <FaCheck size={24} color="#fff" />
                {tp('status.recommended')}
              </p>
            )}
            {result === 'error' && (
              <p>
                <FaTimes size={24} color="#fff" />
                {tp('status.notRecommended')}
              </p>
            )}
            {result === 'warn' && (
              <p>
                <FaTimes size={24} color="#fff" />
                {tp('status.failed')}
              </p>
            )}
          </ResultContent>
        </ProfileData>
      </ProfileContent>
      <MessageError>{result === 'warn' && messageError}</MessageError>
      <AlertBox message={optinText} removeAnimation />
      {accessDash ? (
        <Button
          title={tp('buttons.returnToPlatform')}
          onClick={returnToPlatform}
          style={{ marginTop: 20 }}
        />
      ) : (
        <Button
          title={
            result === 'warn'
              ? tp('buttons.takeAnotherPhoto')
              : tp('buttons.backToStart')
          }
          onClick={result === 'warn' ? handleTryAgain : clearData}
          style={{ marginTop: 20 }}
        />
      )}
    </Content>
  );
};

export default Result;
